export default "__VITE_ASSET__VsNny0Tn__"